export const SEEDING = 'SEEDING';
export const STANDING = 'STANDING';

export const JUNIOR = 'JUNIOR';
export const ADULT = 'ADULT';
export const FAMILY = 'FAMILY';
export const WHEELCHAIR = 'WHEELCHAIR';
export const COMBINED = 'COMBINED';
export const INDIVIDUAL = 'INDIVIDUAL';
export const TEAM = 'TEAM';

export const MIXED = 'MIXED';
export const MALE = 'MALE';
export const FEMALE = 'FEMALE';

export const MAX_BATCH_SIZE = 128;
export const MAX_WTN_BATCH_SIZE = 1000;
